
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import {MallKey} from "@/utils/config"
  
  import message from '@/components/message.vue';
  import {
    authsendSmsCode,
    authvaliteProviderPhone,
    bankFinanceSettlelist,
    settlementAccountinfo,
    settlementAccountsendCode,
    settlementAccountedit,

  } from '@/api/user'
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-message': message,
    }
  })

  export default class ProductList extends Vue {
    private form:any = {
      CardHolder:'',
      BankId:null,
      Phone:'',
      BankCardNumber:'',
    }
    private banklist:any = []
    private num = 60
    private captcha1:any = {}
    private MallKey = MallKey
    private countdown:any = {}
    private code = ''
    private changeShow = false


    private mounted () {
      this.getbanklist()
      this.getinfo()
      // this.$nextTick(()=>{
			// 	/* eslint-disable */
			// 	// eslint-disable-next-line no-undef
			// 	this.captcha1 = new TencentCaptcha('2017604677', this.validationcallback, { //eslint-disable-line
			// 		needFeedBack: false,
			// 	}) as any;
			// 	/* eslint-enable */
			// })
      // console.log(this.userInfo)
    }

    private checkchange(){
      if(!this.form.CardHolder){
        this.$message.error('请输入开户人')
        return
      }
      if(!this.form.BankId){
        this.$message.error('请选择开户行')
        return
      }
      if(!this.form.BankCardNumber){
        this.$message.error('请输入开户账号')
        return
      }
      if(!this.code){
        this.$message.error('请输入验证码')
        return
      }

      this.changeShow = true
    }
    private async confirmchange(){
      
      try{
        let res = await settlementAccountedit({
          ...this.form,
          SmsCode:this.code
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.getinfo()
        }
      }finally{
        //
      }
    }
    private async getinfo(){
      try{
        let res = await settlementAccountinfo({})
        if(res.IsSuccess){
          this.form = res.Result
          this.form.BankId = this.form.BankId||null
          this.code = ''
        }
      }finally{
        //
      }
    }
    private async getbanklist(){
      try{
        let res = await bankFinanceSettlelist({})
        if(res.IsSuccess){
          this.banklist = res.Result
        }
      }finally{
        //
      }
    }
    //发送短信验证码
		// private async validationcallback(e){
		// 	try{
    //     let valite = await authvaliteProviderPhone({
    //       MallKey:this.MallKey,
    //       Account:this.form.Phone
    //     })
    //     if(!valite.IsSuccess){
    //       this.$message.error(valite.Message)
    //       return
    //     }
		// 	  // console.log(e)
		// 	  if(e.ret == 0){
		// 			let res = await settlementAccountsendCode({
		// 				MallKey:this.MallKey,
		// 				Account:this.form.Phone,
		// 				// Type:this.isChangePsd?7:3,
		// 				Ticket:e.ticket,
		// 				Randstr:e.randstr,
    //         FromType:1
		// 			})
		// 			// console.log(res)
		// 			if(res.IsSuccess){
						// this.$message.success('已发送验证码')
						// this.countdown = setInterval(()=>{
            //   if(this.num>1){
            //     this.num--
            //   }else{
            //     clearInterval(this.countdown)
            //     this.num = 60
            //   }
            // },1000)
		// 			}
		// 	  }
    //   }finally{
    //     //
    //   }
		// }
    private async checklogin(){
      // this.captcha1.show(); // 显示验证码

      try{
        let res = await settlementAccountsendCode({})
        if(res.IsSuccess){
          this.$message.success('已发送验证码')
          this.countdown = setInterval(()=>{
            if(this.num>1){
              this.num--
            }else{
              clearInterval(this.countdown)
              this.num = 60
            }
          },1000)
        }
      }finally{

      }
    }
  }
